import React from 'react';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Link from 'components/Link';
import { layoutContext as LayoutContextPropType } from 'lib/CustomPropTypes';


import TitleLogo from 'components/TitleLogo';
import styles from './styles.module.scss';

const PackageTitle = ({ metadata, alternateDisplayFormat }, context) => {
  if (!(metadata && (metadata.title || metadata.logoUrl))) {
    return null;
  }

  const {
    title, logoUrl, seeAllText, seeAllUrl, description,
  } = metadata;
  const { layoutType, vertical } = context;

  const isRailLayout = layoutType === 'leftRail' || layoutType === 'rightRail';

  const isFullWidth = layoutType === 'fullWidth';

  const isTodayVertical = vertical === 'today';
  const isKnowYourValueVertical = vertical === 'knowyourvalue';
  const isNotAlternateDisplay = !alternateDisplayFormat;

  const h2Classes = classNames(
    styles.titleText,
    'relative font-title f7 f8-m lh-none ls-normal mv0',
    {
      'fs-normal bg-primary white f9-l': vertical !== 'today',
      'fs-italic': isTodayVertical,
      'bg-knockout-secondary': isTodayVertical && isNotAlternateDisplay,
      'color-secondary': isTodayVertical && isNotAlternateDisplay,
      'b-primary': isTodayVertical,
      ttl: isKnowYourValueVertical,
    },
  );

  const containerClasses = classNames(
    'pa7 ph8-m df flex-column flex-row-m flex-wrap-m items-baseline',
    'packageTitle',
    styles.packageTitle,
    {
      [styles.rail]: isRailLayout,
      [styles.fullWidth]: isFullWidth,
      'bg-primary': !isTodayVertical,
      'bg-knockout-secondary': (isTodayVertical && isNotAlternateDisplay),
      pb6: description,
      [styles.alternateDisplayFormat]: alternateDisplayFormat,
    },
  );

  const link = seeAllUrl
    ? (
      <Link
        className={classNames(
          'package-title__see-all-link',
          {
            'package-title__see-all-link--alt-color': isTodayVertical && isNotAlternateDisplay,
          },
        )}
        to={seeAllUrl}
      >
        {seeAllText || i18next.t('See All')}
      </Link>
    )
    : null;

  return (
    <div className={containerClasses}>
      <h2 className={h2Classes}>
        <TitleLogo logoUrl={logoUrl} title={title} />
      </h2>
      {link}
      {description && (
        <p
          className={classNames(
            'w-100-m f3 package-title__description',
            {
              white: !isTodayVertical || alternateDisplayFormat,
              'gray-80': isTodayVertical,
            },
          )}
        >
          {description}
        </p>
      )}
    </div>
  );
};

PackageTitle.propTypes = {
  metadata: PropTypes.objectOf(PropTypes.any),
  alternateDisplayFormat: PropTypes.bool,
};

PackageTitle.defaultProps = {
  metadata: {},
  alternateDisplayFormat: false,
};

PackageTitle.contextTypes = LayoutContextPropType;

export default PackageTitle;
